import { z } from 'zod';

/////////////////////////////////////////
// REPORTS SCHEMA
/////////////////////////////////////////

export const ReportsSchema = z.object({
  reportId: z.number().int(),
  cityId: z.number().int(),
  defaultSet: z.number().int(),
  reportType: z.number().int(),
  reportName: z.string(),
  useStartDate: z.number().int(),
  useEndDate: z.number().int(),
  reportLevels: z.number().int(),
  source: z.string(),
  templateName: z.string(),
  requestsPerPage: z.number().int().nullable(),
  SQLWhere: z.string(),
  SQLTables: z.string(),
  personId: z.number().int(),
  classificationId: z.number().int(),
  departmentId: z.number().int(),
  CETopicId: z.number().int(),
  objectType: z.number().int(),
  filter: z.number().int(),
  description: z.string(),
  datePeriod: z.number().int(),
  startDate: z.string(),
  endDate: z.string(),
  defaultTopic: z.number().int(),
  sortColumn: z.string(),
  dateColumn: z.string(),
  canExport: z.number().int(),
  outputFields: z.string(),
})

export type Reports = z.infer<typeof ReportsSchema>

export default ReportsSchema;
